import React, { useState, useEffect } from "react";
import { Layout } from '../Layout';
import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import PatientSearchService from "../../services/patientSearchService";
import ErrorDisplay from '../../services/errorDisplay';
import 'react-notifications-component/dist/theme.css'
import ReactNotification from 'react-notifications-component'
import { Typeahead } from 'react-bootstrap-typeahead';
import AuthService from '../../services/authService';

const UhcgVOB = () => {
    const [previewDisplayed, setPreviewDisplayed] = useState(false);
    const [clientsForDropdown, setClientsForDropdown] = useState([]);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [selectedClient, setSelectedClient] = useState('');
    const [clientCode, setClientCode] = useState('');
    const [clientName, setClientName] = useState('');
    const [policyFromDate, setPolicyFromDate] = useState(null);
    const [policyToDate, setPolicyToDate] = useState(null);
    const [message, setMessage] = useState('');
    const [gender, setGender] = useState(null);
    const [serviceType, setServiceType] = useState(null);
    const [previewImageUrl, setPreviewImageUrl] = useState();
    const [token, setToken] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(() => {
        PatientSearchService.getAvailableClients((data) => {

            var keys = Object.keys(data);
            var dropdownClients = [];

            for (var i = 0; i < keys.length; i++) {
                let item = {};
                item.key = keys[i];
                item.value = data[item.key];
                dropdownClients.push(item);
            }

            setClientsForDropdown(dropdownClients);

            // if only one client is available, auto-select it (populate clientCode/clientName)
            if (dropdownClients && dropdownClients.length === 1) {
                const only = dropdownClients[0];
                const code = only.key || '';
                let name = '';
                if (only.value) {
                    const parts = only.value.split('-');
                    name = parts.length > 1 ? parts[parts.length - 1].trim() : only.value.trim();
                }
                setSelectedClient(code);
                setClientCode(code);
                setClientName(name);
            }

        });

        AuthService.getAuthToken(false, (token) => {
            setToken(token);
        });

    }, []);

    useEffect(() => {
        const formSelector = '#createUhcgVOB';

        const handler = (ev) => {
            try {
                const form = document.querySelector(formSelector);
                if (!form) return;

                const target = ev && ev.target;
                if (!target || !form.contains(target)) return;

                if (form.checkValidity()) {
                    ErrorDisplay.clear();
                }
                if (selectedClient) {
                    try { ErrorDisplay.clear(); } catch (e) { }
                }
            } catch (e) { }
        };

        document.addEventListener('input', handler, true);
        document.addEventListener('change', handler, true);

        document.addEventListener('click', handler, true);

        return () => {
            try {
                document.removeEventListener('input', handler, true);
                document.removeEventListener('change', handler, true);
                document.removeEventListener('click', handler, true);
            } catch (e) { }
        };
    }, []);

    const handleClosePreview = () => {
        setPreviewDisplayed(false);
        if (previewImageUrl) {
            try { URL.revokeObjectURL(previewImageUrl); } catch { }
        }
        setPreviewImageUrl('');
    }

    const handleClose = () => {
        // Clear any existing errors first
        ErrorDisplay.clear();
        
        setShow(false);

        const form = document.querySelector('#createUhcgVOB');
        if (form) {
            try { form.reset(); } catch { }
        }

        // Clear the Typeahead component
        const clientInput = document.querySelector('#client input[type="text"]') || document.querySelector('#client input');
        if (clientInput) {
            try { 
                clientInput.value = ''; 
                // Trigger change event to clear Typeahead selection
                clientInput.dispatchEvent(new Event('input', { bubbles: true }));
            } catch { }
        }

        // Clear all radio button selections
        const radioButtons = form?.querySelectorAll('input[type="radio"]');
        if (radioButtons) {
            radioButtons.forEach(radio => {
                radio.checked = false;
            });
        }

        // clear component state that represent filters/selection
        setSelectedClient('');
        setClientCode('');
        setClientName('');
        setPolicyFromDate(null);
        setPolicyToDate(null);
        setMessage('');
        setGender(null);
        setServiceType(null);

        // clear preview state
        setPreviewDisplayed(false);
        if (previewImageUrl) {
            try { URL.revokeObjectURL(previewImageUrl); } catch { }
        }
        setPreviewImageUrl('');
        setPreviewLoading(false);
    }

    const findInvalidControls = (form) => {
        const invalids = Array.from(form.elements)
            .filter(el => el.willValidate && !el.validity.valid)
            .map(el => ({
                element: el,
                name: el.name || el.id || null,
                message: el.validationMessage,
                validity: el.validity
            }));
        return invalids;
    }

    const previewVOB = () => {
        const form = document.querySelector("#createUhcgVOB");
        var isValid = form.checkValidity();
        const invalids = findInvalidControls(document.querySelector('form'));
        if (invalids.length) {
            console.log('Invalid fields:', invalids);
            invalids[0].element.focus();
        }
        if (!isValid) {
            ErrorDisplay.renderError((
                <ul><li>All required fields must be entered</li></ul>
            ));
            return;
        }

        var startDateParsed = new Date(policyFromDate);
        var endDateParsed = new Date(policyToDate);

        if (startDateParsed > endDateParsed) {
            isValid = false;

            ErrorDisplay.renderError((
                <ul><li>Policy From date must be before Policy To date</li></ul>
            ));
        }

        if (!isValid) {
            return;
        }

        if (previewLoading) {
            return;
        }

        setPreviewLoading(true);
        let serialized = $('#createUhcgVOB').serialize();
        
        // Remove empty dateOfServiceTo parameter to avoid server validation error
        const dateOfServiceToField = document.querySelector('input[name="dateOfServiceTo"]');
        if (dateOfServiceToField && !dateOfServiceToField.value) {
            serialized = serialized.replace(/[&]?dateOfServiceTo=[^&]*/g, '');
            // Clean up any leading & or double &&
            serialized = serialized.replace(/^&/, '').replace(/&&/g, '&');
        }
        
        PatientSearchService.previewUhcgVOB(null, null, serialized, function (resp) {
            // resp can be a Blob (success) or a string message (error)
            if (resp.data instanceof Blob || (resp.data && ((resp.data.size && resp.data.size > 0) || (resp.data.byteLength && resp.data.byteLength > 0)))) {
                const blob = resp.data instanceof Blob ? resp.data : new Blob([resp.data], { type: 'image/jpeg' });
                const url = URL.createObjectURL(blob);
                setPreviewImageUrl(url);
                setPreviewDisplayed(true);
            } else if (typeof resp === 'object') {
                // server sent back an error message (possibly HTML/text)
                ErrorDisplay.renderError(resp.message);
            } else {
                ErrorDisplay.renderError('An error occurred creating UHCG VOB Preview');
            }
            setPreviewLoading(false);
        })
    }

    const filterByClient = (option, state) => {
        if (state.selected.length) {
            return true;
        }
        return option.value.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
    }

    const onStateSelect = (states) => {
        if (states.length < 1) {
            setSelectedClient('');
            setClientCode('');
            setClientName('');
            return;
        }

        var selectedState = states[0];

        setSelectedClient(selectedState.key);
        const code = selectedState.key || '';
        let name = '';
        if (selectedState.value) {
            const parts = selectedState.value.split('-');
            name = parts.length > 1 ? parts[parts.length - 1].trim() : selectedState.value.trim();
        }
        setClientCode(code);
        setClientName(name);
    }

    const ToggleButton = ({ isOpen, onClick }) => (
        <button
            className="toggle-button"
            onClick={onClick}
            onMouseDown={e => {
                e.preventDefault();
            }}>
            {isOpen &&
                <i className="fa fa-chevron-up"></i>
            }
            {!isOpen &&
                <i className="fa fa-chevron-down"></i>
            }
        </button>
    );

    const handleSubmit = () => {
    }

    const openConfirmModal = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        setShowConfirmModal(true);
    }

    const closeConfirmModal = () => setShowConfirmModal(false);

    const confirmCreateVOB = () => {
        const form = document.querySelector('#createUhcgVOB');
        if (form) {
            try { 
                // Remove empty dateOfServiceTo field before submission to avoid server validation error
                const dateOfServiceToField = form.querySelector('input[name="dateOfServiceTo"]');
                if (dateOfServiceToField && !dateOfServiceToField.value) {
                    dateOfServiceToField.removeAttribute('name');
                }
                form.submit(); 
            } catch (err) { console.error(err); }
        }
        setShowConfirmModal(false);
    }

    return (
        <Layout>
            <ReactNotification />
            <div className="g-mx-25 mb-3 vob">
                <div className="g-ml-25">
                    <h1>Create UHCG VOB</h1>
                </div>
                <Form
                    id="createUhcgVOB"
                    method="post"
                    action="/api/createUhcgVOB"
                    target="new"
                    className={previewDisplayed ? 'hidden' : ''}
                >
                    <Row className="vobFormRow px-5 pt-3">
                        <Col md={12}>
                            <h4 className="label-title">Provider</h4>
                        </Col>
                        <Col md={12} className="pl-5 ml-4">
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerTaxId">
                                        <Form.Label column md={4}>
                                            Tax ID:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="providerTaxId" as="input" maxLength={9} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerName" className="align-items-center">
                                        <Form.Label column md={4} className="required">
                                            Name:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="providerName" required as="input" maxLength={35} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerContact">
                                        <Form.Label column md={3}>
                                            Contact:
                                        </Form.Label>
                                        <Col md={9}>
                                            <Form.Control name="providerContact" as="input" maxLength={30} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerAddress">
                                        <Form.Label column md={4} className="required">
                                            Address:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="providerAddress" required as="input" maxLength={30} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerAddressTwo">
                                        <Form.Label column md={4}>
                                            Address2:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="providerAddressTwo" as="input" maxLength={30} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerCityStateZip" className="align-items-center">
                                        <Form.Label column md={3} className="required text-end">
                                            City:
                                        </Form.Label>
                                        <Col md={9}>
                                            <div className="d-flex align-items-center">
                                                <Form.Control
                                                    name="providerCity"
                                                    required
                                                    style={{ width: '120px' }}
                                                    maxLength={20}
                                                />
                                                <Form.Label column className="required pr-0">
                                                    State
                                                </Form.Label>
                                                <Form.Control
                                                    name="providerState"
                                                    required
                                                    style={{ width: '70px' }}
                                                    maxLength={2}
                                                />
                                                <Form.Label column className="required pr-0">
                                                    Zip Code
                                                </Form.Label>
                                                <Form.Control
                                                    name="providerZip"
                                                    required
                                                    style={{ width: '80px' }}
                                                    maxLength={10}
                                                    minLength={5}
                                                    pattern="[0-9]{5}(-[0-9]{4})?"
                                                    title="ZIP code must be 5 digits (12345) or 9 digits (12345-6789)"
                                                />
                                            </div>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerEmail">
                                        <Form.Label column md={4}>
                                            Email:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="providerEmail" type="email" as="input" maxLength={120} />
                                        </Col>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerPhone">
                                        <Form.Label column md={4} className="required">
                                            Phone:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="providerPhone" required as="input" maxLength={20} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="providerFax" className="align-items-center">
                                        <Form.Label column md={3} className="required">
                                            Fax:
                                        </Form.Label>
                                        <Col md={9}>
                                            <Form.Control name="providerFax" required as="input" maxLength={20} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="vobFormRow px-5 pt-3">
                        <Col md="12">
                            <h4 className="label-title">Patient</h4>
                        </Col>
                        <Col md={12} className="pl-5 ml-4">
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="uhcgMemberId">
                                        <Form.Label column md={4} className="label-title">
                                            UHCG Member ID:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="uhcgMemberId" as="input" maxLength={9}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={8}>
                                    <Form.Group as={Row} controlId="uhcgMemberId">
                                        <Col md={7} className="member-id-card">
                                            <span>** Member ID is required if already existing. If not existing leave blank to create new ID</span>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="patientLastName">
                                        <Form.Label column md={4} className="required">
                                            Last Name:
                                        </Form.Label>
                                        <Col md={8} >
                                            <Form.Control name="patientLastName" required={true} as="input" maxLength={30}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="patientFirstName">
                                        <Form.Label column md={4} className="required">
                                            First Name:
                                        </Form.Label>
                                        <Col md={8} >
                                            <Form.Control name="patientFirstName" required={true} as="input" maxLength={30}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="patientMiddleInitial">
                                        <Form.Label column md={3}>
                                            Middle Initial:
                                        </Form.Label>
                                        <Col md={9}>
                                            <Form.Control name="patientMiddleInitial" as="input" maxLength={1}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="patientDOB">
                                        <Form.Label column md={4} className="required">
                                            DOB:
                                        </Form.Label>
                                        <Col md={8} >
                                            <Form.Control name="patientDOB" type="date" required={true} as="input"></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="patientGender">
                                        <Form.Label column md={4} className="required">
                                            Gender:
                                        </Form.Label>
                                        <Col md={8} >
                                            <Form.Check inline type="radio" name="patientGender" id="male" label="Male" value="1" onChange={e => setGender(e.target.value)} />
                                            <Form.Check inline type="radio" name="patientGender" id="female" label="Female" value="2" onChange={e => setGender(e.target.value)} />
                                            <input type="text" name="patientGenderRequired" required style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }} value={gender || ''} onChange={() => {}} tabIndex={-1} aria-hidden="true" />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="vobFormRow px-5 pt-3">
                        <Col md="12">
                            <h4 className="label-title">Policy</h4>
                        </Col>
                        <Col md={12} className="pl-5 ml-4">
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="patientPolicyNumber">
                                        <Form.Label column md={4} className="required">
                                            Policy #:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control 
                                                name="patientPolicyNumber" 
                                                required={true} 
                                                as="input" 
                                                maxLength={20}
                                                pattern="^[A-Za-z0-9._-]+$"
                                                title="Enter a valid Policy #. Characters permitted are A–Z, a–z, 0–9, hyphen (-), dot (.), and underscore (_). Spaces and all other special characters are not allowed."
                                                onBlur={e => { e.target.value = e.target.value.trim(); }}
                                                onInput={e => {
                                                    // Remove spaces and disallowed characters as user types
                                                    const cleaned = e.target.value.replace(/[^A-Za-z0-9._-]/g, '');
                                                    if (e.target.value !== cleaned) e.target.value = cleaned;
                                                }}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="policyFrom">
                                        <Form.Label column md={4} className="required">
                                            Policy From:
                                        </Form.Label>
                                        <Col md={8} >
                                            <Form.Control name="policyFrom" type="date" required={true} as="input" onChange={(e) => setPolicyFromDate(e.target.value)}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="policyTo">
                                        <Form.Label column md={5} className="required">
                                            Policy To:
                                        </Form.Label>
                                        <Col md={7} >
                                            <Form.Control name="policyTo" type="date" required={true} as="input" onChange={(e) => setPolicyToDate(e.target.value)}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="coverageLimit">
                                        <Form.Label column md={4} className="required">
                                            Benefit Limit $:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="coverageLimit" required={true} as="input" ></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="deductible">
                                        <Form.Label column md={4}>
                                            Deductible $:
                                        </Form.Label>
                                        <Col md={8} >
                                            <Form.Control name="deductible" as="input"></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="copayment">
                                        <Form.Label column md={5}>
                                            Coinsurance Rate %:
                                        </Form.Label>
                                        <Col md={7} >
                                            <Form.Control name="copayment" as="input"></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="benefitRemaining">
                                        <Form.Label column md={4}>
                                            Benefit Remaining $:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="benefitRemaining" as="input" ></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="deductibleRemaining">
                                        <Form.Label column md={4}>
                                            Deductible Remaining $:
                                        </Form.Label>
                                        <Col md={8} >
                                            <Form.Control name="deductibleRemaining" as="input"></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="coinsuranceToBeMet">
                                        <Form.Label column md={5}>
                                            Coinsurance To Be Met %:
                                        </Form.Label>
                                        <Col md={7} >
                                            <Form.Control name="coinsuranceToBeMet" as="input"></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="vobFormRow px-5 pt-3">
                        <Col md="12">
                            <h4 className="label-title">Services</h4>
                        </Col>
                        <Col md={12} className="pl-5 ml-4">
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="dateOfServiceFrom">
                                        <Form.Label column md={4} className="required">
                                            Date of Service From:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="dateOfServiceFrom" type="date" required={true} as="input"></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="dateOfServiceTo">
                                        <Form.Label column md={4}>
                                            Date of Service To:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="dateOfServiceTo" type="date" as="input"></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="serviceType">
                                        <Form.Label column md={4} className="required">
                                            Type of Service:
                                        </Form.Label>
                                        <Col md={8} className="px-0">
                                            <Form.Check inline type="radio" name="serviceType" id="inpatient" label="Inpatient" value="1" onChange={e => setServiceType(e.target.value)} />
                                            <Form.Check inline type="radio" name="serviceType" id="outpatient" label="Outpatient" value="2" onChange={e => setServiceType(e.target.value)} />
                                            <input type="text" name="serviceTypeRequired" required style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }} value={serviceType || ''} onChange={() => {}} tabIndex={-1} aria-hidden="true" />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="diagnosis">
                                        <Form.Label column md={4} className="required">
                                            Diagnosis:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="diagnosis" required={true} as="input" maxLength={60}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="procedure">
                                        <Form.Label column md={3} className="required">
                                            Procedure:
                                        </Form.Label>
                                        <Col md={9} >
                                            <Form.Control name="procedure" required={true} as="input" maxLength={100}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="exclusionsAndLimitations">
                                        <Form.Label column md={4}>
                                            Exclusions & Limitations:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="exclusionsAndLimitations" as="textarea" rows="4" onChange={e => setMessage(e.target.value)} maxLength={254}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={8}>
                                    <Form.Group as={Row} controlId="comments">
                                        <Form.Label column md={2}>
                                            Comments:
                                        </Form.Label>
                                        <Col md={10}>
                                            <Form.Control name="comments" as="textarea" rows="4" onChange={e => setMessage(e.target.value)} maxLength={120}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="vobFormRow px-5">
                        <Col md="12">
                            <h4 className="label-title">Signature</h4>
                        </Col>
                        <Col md={12} className="pl-5 ml-4">
                            <Row>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="sincerely">
                                        <Form.Label column md={4} className="required">
                                            Sincerely:
                                        </Form.Label>
                                        <Col md={8}>
                                            <Form.Control name="sincerely" required={true} as="input" maxLength={30}></Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group as={Row} controlId="searchType">
                                        <Form.Label column md={4} className="required">
                                            Carrier:
                                        </Form.Label>
                                        <Col md={8}>
                                            {clientsForDropdown && clientsForDropdown.length === 1 ? (
                                                <>
                                                    <Form.Control name="clientDisplay" readOnly value={clientsForDropdown[0].value || ''} />
                                                    <input type="hidden" name="client" value={clientsForDropdown[0].key || clientCode || ''} />
                                                    <input type="hidden" name="clientCode" value={clientsForDropdown[0].key || clientCode || ''} />
                                                    <input type="hidden" name="clientName" value={(clientsForDropdown[0].value && clientsForDropdown[0].value.split('-').slice(-1)[0].trim()) || clientName || ''} />
                                                </>
                                            ) : (
                                                <>
                                                    <Typeahead
                                                        id="client"
                                                        flip={true}
                                                        onChange={onStateSelect}
                                                        options={clientsForDropdown}
                                                        labelKey="value"
                                                        placeholder="Please Select"
                                                        filterBy={filterByClient}
                                                        selected={selectedClient ? clientsForDropdown.filter(client => client.key === selectedClient) : []}
                                                    >
                                                        {({ isMenuShown, toggleMenu }) => (
                                                            <ToggleButton isOpen={isMenuShown} onClick={e => { e.preventDefault(); toggleMenu(); }} />
                                                        )}
                                                    </Typeahead>
                                                    <input type="text" name="client" required style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }} value={selectedClient || ''} onChange={() => {}} tabIndex={-1} aria-hidden="true" />
                                                    <input type="hidden" name="clientCode" value={clientCode || ''} />
                                                    <input type="hidden" name="clientName" value={clientName || ''} />
                                                </>
                                            )}
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <input type="hidden" name="Token" value={token}></input>
                    </Row>
                    {previewDisplayed &&
                        <Row>
                            <Col md className="pdf-col" style={{ height: '600px' }}>
                                <iframe width="100%" height="100%" src={previewImageUrl}></iframe>
                            </Col>
                        </Row>
                    }
                    {previewLoading &&
                        <div className="text-center providersLoading">
                            <div className="spinner-border"></div>
                        </div>
                    }
                    <Row className="mt-3">
                        <Col md="12" className="text-center">
                            {previewDisplayed &&
                                <>
                                    <Button onClick={openConfirmModal} type="button" variant="primary" className="btn btn-md u-btn-primary mr-2">Create VOB</Button>
                                    <Button onClick={handleClosePreview} variant="primary" className="btn btn-md u-btn-primary mr-2">Back</Button>
                                </>
                            }
                            {!previewDisplayed &&
                                <Button onClick={previewVOB} variant="primary" className="btn btn-md u-btn-primary mr-2">Preview</Button>
                            }
                            <Button onClick={handleClose} variant="primary" className="gmmi-red">Reset</Button>
                        </Col>
                    </Row>
                </Form >
                <Modal show={showConfirmModal} onHide={closeConfirmModal} centered size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Create VOB</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        UHCG VOB can only be issued once benefits have been confirmed and members services are covered. 
                        By creating this VOB you agree to cover the medical complaint and treatment entered in the VOB. 
                        If the services are covered, then please click OK to acknowledge and proceed or click Cancel.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="gmmi-red" onClick={closeConfirmModal}>Cancel</Button>
                        <Button variant="primary" className="btn btn-md u-btn-primary mr-2" onClick={confirmCreateVOB}>OK</Button>
                    </Modal.Footer>
                </Modal>

            </div>
        </Layout >
    );
}

export default UhcgVOB;